import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import {AppConst, appRoutePath} from "../_helpers/AppConts";
import {getUserLocal} from "../_helpers/HNTUtil";
import Collapse from "react-bootstrap/Collapse";
import "../../assets/styles/Sidebar.css";
const logo = require("../../assets/logo.png");

const Logo = (props) => {
    let {store} = props;
    if (store && store.id && store.logo_base64) {
        return (
            <img src={`data:image/jpeg;base64,${store.logo_base64}`} alt="logo"/>
        );
    }

    return (
        <img src={logo} alt="logo"/>
    );
}


function StoreProfile (props) {
    let {store} = props;
    if (store && store.name) {
        return (
            <div className="justify-content-center align-items-start p-1">
                <div className="text-center">
                    <h6 className="profile-name font-weight-bold text-black">{store.name}</h6>
                    <h6 className="designation text-muted text-smail">{store.address}</h6>
                    <h6 className="designation text-muted text-small">{store.phone_number}</h6>
                </div>
            </div>
        );
    }
    return (<div></div>);
}


function MenuAdmin(props) {
    const showMyStore =  props.storeAccessed && props.storeAccessed.id && props.storeAccessed.id > 0 && props.user && props.user.role === AppConst.RoleUser.ROLE_ADMIN;

    return (
        <div>
            <li className={ props.isPathActive(appRoutePath.Dashboard) ? 'nav-item active' : 'nav-item' }>
                <Link className="nav-link" to={appRoutePath.Dashboard}>
                    <i className="mdi mdi-television menu-icon"/>
                    <span className="menu-title">Dashboard</span>
                </Link>
            </li>

            <li className={ props.isPathActive(appRoutePath.CheckInPage) ? 'nav-item active' : 'nav-item' }>
                <Link className="nav-link" to={appRoutePath.CheckInPage}>
                    <i className="fa fa-list-alt menu-icon"/>
                    <span className="menu-title">Check-In-Out</span>
                </Link>
            </li>

            <li className={ props.isPathActive(appRoutePath.AppointmentAdminPage) ? 'nav-item active' : 'nav-item' }>
                <Link className="nav-link" to={appRoutePath.AppointmentAdminPage}>
                    <i className="fa fa-calendar-plus-o menu-icon"/>
                    <span className="menu-title">Appointments</span>
                </Link>
            </li>

            <li className={ props.isPathActive('/message') ? 'nav-item active' : 'nav-item' }>
                <div className= { props.messageMenuOpen ? 'nav-link menu-expanded' : 'nav-link' }
                     data-toggle="collapse"
                     onClick={ () => props.toggleMenuState('messageMenuOpen') }>
                    <i className="fa fa-send menu-icon"/>
                    <span className="menu-title">Messaging</span>
                    <i className="menu-arrow"/>
                </div>

                <Collapse in={props.messageMenuOpen}>
                    <ul className="nav flex-column sub-menu">
                        <li className="nav-item">
                            <Link className={props.isPathActive(appRoutePath.MessageSend) ? 'nav-link active' : 'nav-link'} to={appRoutePath.MessageSend}>
                                Send
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={props.isPathActive(appRoutePath.MessagePresets) ? 'nav-link active' : 'nav-link'} to={appRoutePath.MessagePresets}>
                                Drip Messages
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={props.isPathActive(appRoutePath.MessageWelcome) ? 'nav-link active' : 'nav-link'} to={appRoutePath.MessageWelcome}>
                                Welcome Message
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={props.isPathActive(appRoutePath.MessageTemplete) ? 'nav-link active' : 'nav-link'} to={appRoutePath.MessageTemplete}>
                                Templates
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={props.isPathActive(appRoutePath.MessageReport) ? 'nav-link active' : 'nav-link'} to={appRoutePath.MessageReport}>
                                Pending/History
                            </Link>
                        </li>
                    </ul>
                </Collapse>
            </li>

            <li className={ props.isPathActive(appRoutePath.InboxPage) ? 'nav-item active' : 'nav-item' }>
                <Link className="nav-link" to={appRoutePath.InboxPage}>
                    <i className="fa fa-inbox  menu-icon"/>
                    <span className="menu-title">Inboxs</span>
                </Link>
            </li>


            <li className={ props.isPathActive(appRoutePath.CustomerPage) ? 'nav-item active' : 'nav-item' }>
                <div className={ props.customerMenuOpen ? 'nav-link menu-expanded' : 'nav-link' }
                     data-toggle="collapse"
                     onClick={ () => props.toggleMenuState('customerMenuOpen') }>
                    <i className="fa fa-address-book menu-icon"/>
                    <span className="menu-title">Customers</span>
                    <i className="menu-arrow"/>
                </div>
                <Collapse in={ props.customerMenuOpen }>
                    <ul className="nav flex-column sub-menu">
                        <li className="nav-item">
                            <Link className={ props.isPathActive(appRoutePath.CustomerPage) ? 'nav-link active' : 'nav-link' } to={appRoutePath.CustomerPage}>List</Link>
                        </li>
                        <li className="nav-item">
                            <Link className={ props.isPathActive(appRoutePath.CustomerGroupPage) ? 'nav-link active' : 'nav-link' } to={appRoutePath.CustomerGroupPage}>Group</Link>
                        </li>
                    </ul>
                </Collapse>
            </li>

            <li className={ props.isPathActive('/promos') ? 'nav-item active' : 'nav-item' }>
                <Link className="nav-link" to="/promos">
                    <i className="fa fa-gift  menu-icon"/>
                    <span className="menu-title">Promotions</span>
                </Link>
            </li>

            <li className={ props.isPathActive('/services') ? 'nav-item active' : 'nav-item' }>
                <Link className="nav-link" to="/services">
                    <i className="fa fa-inbox menu-icon"/>
                    <span className="menu-title">Services Menu</span>
                </Link>
            </li>

            <li className={ props.isPathActive('/staffs') ? 'nav-item active' : 'nav-item' }>
                <Link className='nav-link' to='/staffs'>
                    <i className="fa fa-user-circle menu-icon"/>
                    <span className="menu-title">Employees</span>
                </Link>
            </li>

            <MenuMaster {...props}/>

            {showMyStore &&
            <li className={props.isPathActive(appRoutePath.StoreDetailPage) ? 'nav-item active' : 'nav-item'}>
                <Link className='nav-link' to={appRoutePath.StoreDetailPage + "/" + props.storeAccessed.id}>
                    <i className="fa fa-user-circle menu-icon"/>
                    <span className="menu-title">My Store</span>
                </Link>
            </li>
            }
        </div>
    );
}


function MenuMaster (props) {
    if (props.user && props.user.role === AppConst.RoleUser.ROLE_MASTER) {
        return (
            <div>
                <li className= {props.isPathActive(appRoutePath.StorePage) ? 'nav-item active' : 'nav-item' }>
                    <Link className="nav-link display-none" to={appRoutePath.StorePage}>
                        <i className="mdi mdi-store menu-icon"/>
                        <span className="menu-title">Stores</span>
                    </Link>
                </li>

                {props.storeAccessed && props.storeAccessed.id &&
                <li className={props.isPathActive('/config') ? 'nav-item active' : 'nav-item'}>
                    <div className={props.configMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} data-toggle="collapse"
                         onClick={() => props.toggleMenuState('configMenuOpen')}>
                        <i className="fa fa-cogs menu-icon"/>
                        <span className="menu-title">Config</span>
                    </div>

                    <Collapse in={props.configMenuOpen}>
                        <ul className="nav flex-column sub-menu">
                            <li className={ props.isPathActive(appRoutePath.ShortUrl) ? 'nav-item active' : 'nav-item' }>
                                <Link className='nav-link' to={appRoutePath.ShortUrl}>
                                    {/*<i className="fa fa-link menu-icon"/>*/}
                                    <span className="menu-title">Shorten Url</span>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={props.isPathActive(appRoutePath.StoreConfigPage) ? 'nav-link active' : 'nav-link'}
                                      to={appRoutePath.StoreConfigPage}>
                                    {/*<i className="fa fa-text-width menu-icon"/>*/}
                                    <span className="menu-title">Message</span>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={props.isPathActive(appRoutePath.HostedWidgetPage) ? 'nav-link active' : 'nav-link'}
                                      to={appRoutePath.HostedWidgetPage}>
                                    {/*<i className="fa fa-wechat menu-icon"/>*/}
                                    <span className="menu-title">Hosted Widget</span>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={props.isPathActive(appRoutePath.SocialMediaPage) ? 'nav-link active' : 'nav-link'}
                                      to={appRoutePath.SocialMediaPage}>
                                    {/*<i className="fa fa-wechat menu-icon"/>*/}
                                    <span className="menu-title">Social Media Contacts</span>
                                </Link>
                            </li>
                        </ul>
                    </Collapse>
                </li>
                }
            </div>
        );
    } else {
        return (<div></div>);
    }
}


function Menu(props) {
    if (props.user && props.user.role === AppConst.RoleUser.ROLE_ADMIN) {
        return (<MenuAdmin {...props}/>);
    }
    else if (props.user && props.user.role === AppConst.RoleUser.ROLE_MASTER) {
        if (props.storeAccessed) {
            return (<MenuAdmin {...props}/>);
        } else {
            return (<MenuMaster {...props}/>);
        }
    } else {
        return (<p>Empty</p>);
    }
}



class Sidebar extends React.Component {
    constructor() {
        super();
        this.state = {};

        this.isPathActive = this.isPathActive.bind(this);
        this.toggleMenuState = this.toggleMenuState.bind(this);
    }

    toggleMenuState (menuState) {
        if (this.state[menuState]) {
            this.setState({[menuState] : false});
        } else if(Object.keys(this.state).length === 0) {
            this.setState({[menuState] : true});
        } else {
            Object.keys(this.state).forEach(i => {
                this.setState({[i]: false});
            });
            this.setState({[menuState] : true});
        }
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.location !== prevProps.location) {
            this.onRouteChanged();
        }
    }


    onRouteChanged() {
        document.querySelector('#sidebar').classList.remove('active');
        Object.keys(this.state).forEach(i => {
            this.setState({[i]: false});
        });

        const dropdownPaths = [
            {path: '/message', state: 'messageMenuOpen'},
            {path: '/config', state: 'configMenuOpen'},
            {path: '/customer', state: 'customerMenuOpen'}
        ];

        dropdownPaths.forEach((obj => {
            if (this.isPathActive(obj.path)) {
                this.setState({[obj.state] : true})
            }
        }));
    }

    isPathActive (path) {
        let location = this.props.location ? this.props.location : (this.props.location.location ? this.props.location.location : null);
        if (location && location.pathname) {
            return location.pathname.startsWith(path);
        }
        return false;
    }

    componentDidMount() {
        this.onRouteChanged();

        // add className 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
        const body = document.querySelector('body');
        document.querySelectorAll('.sidebar .nav-item').forEach((el) => {

            el.addEventListener('mouseover', function() {
                if(body.classList.contains('sidebar-icon-only')) {
                    el.classList.add('hover-open');
                }
            });
            el.addEventListener('mouseout', function() {
                if(body.classList.contains('sidebar-icon-only')) {
                    el.classList.remove('hover-open');
                }
            });
        });
    }

    render () {
        const user = getUserLocal();

        return (
            <nav className="sidebar sidebar-offcanvas" id="sidebar">
                {/*<div className="text-center sidebar-brand-wrapper d-flex align-items-center">*/}
                <div className="text-center sidebar-brand-wrapper sidebar-actions">
                    <a className="sidebar-brand brand-logo" href={appRoutePath.Dashboard}>
                        <Logo store={this.props.storeAccessed}/>
                    </a>
                </div>

                {/*<div className="text-left sidebar-brand-wrapper d-flex align-items-start" id="sidebar-profile-store">*/}
                <div id="sidebar-profile-store">
                    <div className="sidebar-actions">
                        <hr className="mt-0 mb-0 pt-0 pb-0"/>
                        <StoreProfile store={this.props.storeAccessed}/>
                        <hr className="mt-0 mb-0 pt-0 pb-0"/>
                    </div>
                </div>

                <ul className="nav">
                    <Menu {...this.state}
                          storeAccessed={this.props.storeAccessed}
                          user={user}
                          isPathActive={this.isPathActive}
                          toggleMenuState={this.toggleMenuState}
                    />
                    {/*
                      <li className={ this.isPathActive('/feedback') ? 'nav-item active' : 'nav-item' }>
                        <Link className="nav-link" to="/feedback">
                          <i className="fa fa-comment menu-icon"/>
                          <span className="menu-title">Feedbacks</span>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href="#" rel="noopener noreferrer" target="_blank">
                          <i className="mdi mdi-file-outline menu-icon"></i>
                          <span className="menu-title">Documentation</span>
                        </a>
                      </li>
                      */}
                </ul>
            </nav>
        );
    }
}

const mappingSideBar = connect(null, null)(Sidebar);
export default withRouter(mappingSideBar);
